import { createContext, useContext } from "react";

const SidebarContext = createContext();

export default function Sidebar({ children }) {
  return (
    <SidebarContext.Provider value={{}}>
      <aside className="h-screen shadow-md transition-all duration-300" id="sidebar">
        <nav className="h-full flex flex-col border-r shadow-sm">
        <div className="p-3 pb-1 flex justify-center items-center">
            <img 
              src="/android-chrome-144x144.png" 
              alt="Logo" 
              className="w-11 h-11 " // Adjust size as needed
            />
        </div>
          <ul className="flex-1 px-3 mt-10">{children}</ul>
        </nav>
      </aside>
    </SidebarContext.Provider>
  );
}

export function SidebarItem({ icon, text, active, onClick }) {
  return (
    <li
      className={`relative flex items-center py-2 px-3 my-1 font-medium rounded-md cursor-pointer transition-colors group
        ${active ? "text-[#75623F] bg-[#FDFDFD]" : "hover:bg-[#D4CEC3] text-brown-200"}`}
      onClick={onClick}
    >
      {icon}
      
      {/* Tooltip (Only visible on hover) */}
      <div
        className="absolute left-full rounded-md px-12 py-2 ml-2 bg-amber-50 text-brown-200 text-ml font-medium
        invisible opacity-0 -translate-x-3 transition-all group-hover:visible group-hover:opacity-100 group-hover:translate-x-0"
      >
        {text}
      </div>
    </li>
  );
}
